define.alias("ember-math-helpers/helpers/fround", "media/helpers/fround");